import { HttpClient } from '@adapters/HttpClient';

export interface ContractTemplate {
    id: string;
    name: string;
}

export class ContractTemplatesApiAdapter {
    constructor(private httpClient: HttpClient) {}

    async getTemplates(): Promise<ContractTemplate[]> {
        const response = await this.httpClient.get<ContractTemplate[]>('/contracts/templates');
        return Array.isArray(response) ? response : [];
    }
}

